import { connect }                  from 'react-redux';
import { useContext }               from 'react';
import { context }                  from 'context';

import useDenyAccess                from '../../pages/root/useDenyAccess';
import Loader                       from 'components/Loader';
import SignInButton                 from './SignInButton';
import DenyAccess                   from './DenyAccess';

import {
         langType,
         objType,
         userInfoType,
       }                            from 'types'


import { reducerType }              from 'reducer';

import { words }                    from 'utils/dictionary';

import { colors }                   from 'utils/colors'
//import logo                         from 'images/yisumaticaLogo.png';
import { makeStyles }               from "makeStyles";


const logo  = 'https://www.yisumatica.org.il/yisumaticaImages/yisumaticaLogo.png';


const useStyles = makeStyles()(() => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        overflow:        'hidden',
        transition:      'opacity 0.6s',
    },
    LoaderPage: {
      position:        'fixed',
      top:             0,
      left:            0,
      minHeight:       '100vh',
      minWidth:        '100vw',
      maxHeight:       '100vh',
      maxWidth:        '100vw',
      backgroundColor: '#FFF',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      flexFlow:        'column',
    },
    loading: {
      fontWeight:  'bold',
      fontSize:     27,
      marginBottom: 40
    },
    denyAccess: {
      fontWeight:  'bold',
      fontSize:     22,
      marginBottom: 8
    },
    submitButton: {
      width:           200,
      height:          35,
      fontSize:        20,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      backgroundColor: colors.primary,
      color:           '#FFF',
      fontWeight:      'bold',
      cursor:          'pointer',
      boxShadow:       '2px 4px 9px rgba(0,0,0,0.1)',
      left:            '50%',
      marginTop:       20,
      marginLeft:      8,
      marginRight:     8,
      '&:hover': {
        opacity: 0.5
      }
    },
    positionAbsolute: {
      position:  'absolute',  
      transform: 'translate(-50%, 0%)',
    },
    logo: {
      width:              200,
      height:             100,
      backgroundImage:    `url(${ logo })`,
      backgroundPosition: 'center',
      backgroundSize:     'contain',
      backgroundRepeat:   'no-repeat',
    },
    buttonContainer: {
      width:          '100%',
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center'
    },
    transformLogo: {
      transform: 'translate(0px, -120px)',
    }
}))

type LoaderPageProps = {
  userInfo:           userInfoType;
  dataUpdateState:    objType;
  lang:               langType;
  goToVideoOnce:      boolean;
}

const LoaderPage: React.FC<LoaderPageProps> = ({
  userInfo,
  dataUpdateState,
  lang,
  goToVideoOnce,
}) => {

const { userIsGuest } = useContext(context);

const { classes } = useStyles();


  const { showLoader, showSigninButton, showDenyAccess } = useDenyAccess(userIsGuest, goToVideoOnce, dataUpdateState, userInfo)

  return (
    <>
        {
          showLoader
          &&
          <div className = { classes.LoaderPage }>
            <div className = { classes.loading } dir = 'rtl'>
               { words['loading'][lang] }
            </div>
            <Loader/>
          </div>
        }
        {
          showSigninButton && <SignInButton/>
        }
        {
          showDenyAccess && <DenyAccess/>
        }
    </>
  );
}




const mapStateToProps = (reducer: reducerType) => {

  return {
    lang:            reducer.components.lang,
    dataUpdateState: reducer.data.dataUpdateState,
    userInfo:        reducer.data.userInfo,
}};

export default connect(mapStateToProps)(LoaderPage);
